/* eslint-disable camelcase */
export const FRIEND_SEAECH_TABLE_COL = [
  {
    displayName: "S.No",
    key: "s.no",
  },
  {
    displayName: "Member ID",
    key: "id",
  },
  {
    displayName: "Name",
    // key: ["memberName", "memberAddress"],
    key: "fullName",
  },
  // {
  //   displayName: "Phone & Email",
  //   key: ["phone", "email"],
  // },
  {
    displayName: "Division/Sub Division",
    key: "division",
  },
  // {
  //   displayName: "Sub Division",
  //   // key: "subDivisionName",
  // },
  {
    displayName: "Org Structure",
    key: "orgstructure",
  },
  {
    displayName: "Date Of First Meeting",
    key: "dateOfFirstMeeting",
  },
  {
    displayName: "FTM Month",
    key: "FTM_Month",
  },
  {
    displayName: "Mobile Number",
    key: "mobile",
  },
  {
    displayName: "Address",
    key: "address",
  },
  // {
  //   displayName: "Area",
  //   key: "area",
  // },
  // {
  //   displayName: "Zone",
  //   key: "zone",
  // },
  // {
  //   displayName: "Region",
  //   key: "region",
  // },
  // {
  //   displayName: "Chapter",
  //   key: "chapter",
  // },
  // {
  //   displayName: "District",
  //   key: "district",
  // },
  // {
  //   displayName: "Block",
  //   key: "block",
  // },
  // {
  //   displayName: "Status",
  //   key: "status",
  // },
  //   {
  //     displayName: "Action",
  //     key: "action",
  //   },
];

export const MEMBER_REPORT_TABLE_COL = [
  {
    displayName: "S.No",
    key: "s.no",
  },
  {
    displayName: "Member ID",
    key: "id",
  },
  {
    displayName: "Name",
    // key: ["memberName", "memberAddress"],
    key: "fullName",
  },
  // {
  //   displayName: "Phone & Email",
  //   key: ["phone", "email"],
  // },
  {
    displayName: "Division/Sub Division",
    key: "division",
  },
  // {
  //   displayName: "Sub Division",
  //   // key: "subDivisionName",
  // },
  {
    displayName: "Org Structure",
    key: "orgstructure",
  },
  {
    displayName: "Mobile Number",
    key: "mobile",
  },
  {
    displayName: "Email Id",
    key: "email",
  },
  {
    displayName: "Address",
    key: "address",
  },
  {
    displayName: "Role",
    key: "role",
  },
  {
    displayName: "Honorary District Chief 1",
    key: "honoraryDistrictChief1",
  },
  {
    displayName: "Honorary District Chief 2",
    key: "honoraryDistrictChief2",
  },
];

export const FRIEND_SEARCH_COL = [
  "memberId",
  "fullName",
  "emailId",
  "mobileNumber",
  "addressLine1",
  "addressLine2",
  "city",
  "pincode",
  "state",
  "nationalityId",
  "divisionId",
  "divisionName",
  "subdivisionId",
  "subDivisionName",
  "introducedBy",
  "areaId",
  "areaName",
  "clusterId",
  "clusterName",
  "zoneId",
  "zoneName",
  "regionId",
  "regionName",
  "chapterId",
  "chapterName",
  "districtId",
  "districtName",
  "blockId",
  "blockName",
  "introducerName",
  "introducerEmail",
  "introducerMobileNumber",
];
